import { useTranslation } from "react-i18next";
import { Floor } from "@/types/globalTypes";
import { Skeleton } from "../ui/skeleton";
import { ArabicOrdinal, EnglishOrdinal } from "@/types/enums";

function TablesFilter({
  floors,
  setSelectedFloor,
  selectedFloor,
  isLoading,
}: {
  floors: Floor[];
  setSelectedFloor: React.Dispatch<React.SetStateAction<Floor>>;
  selectedFloor: Floor;
  isLoading: boolean;
}) {
  const { t, i18n } = useTranslation();

  const handleSelectedFloor = (floor: Floor) => {
    setSelectedFloor(floor);
  };

  if (isLoading)
    return (
      <div className="thin-scrollbar flex w-full items-center gap-2 overflow-x-auto">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton
            key={i}
            className=" h-[50px] w-[100px] dark:bg-slate-600 dark:bg-opacity-35"
          />
        ))}
      </div>
    );

  return (
    <div className="thin-scrollbar flex w-full items-center gap-2 overflow-x-auto">
      {floors.map((floor) => (
        <button
          onClick={() => handleSelectedFloor(floor)}
          key={floor._id}
          className={`border-2 font-semibold ${
            selectedFloor._id === floor._id
              ? "bg-sidebar text-skyblue"
              : "bg-skyblue text-sidebar"
          } w-fit text-nowrap rounded-md px-5 py-2`}
        >
          {t("TablesFilter.floorLabel", {
            floor:
              i18n.language === "ar"
                ? ArabicOrdinal[Number(floor?.number) - 1] || floor?.number
                : EnglishOrdinal[Number(floor?.number) - 1] || floor?.number,
          })}
        </button>
      ))}
    </div>
  );
}

export default TablesFilter;
